import type {
    ColummListColumn,
} from "app/pages/sales-intelligence/common-components/search-results-table/types";
import {
    buildColumnsFromDescriptors,
    createColumnFactoryList,
} from "app/pages/sales-intelligence/common-components/search-results-table/utils/columns";
import type {
    CrmRecordColumnDataType,
    CrmRecordsColumn,
    CrmRecordsRow,
} from "app/pages/sales-intelligence/domain/crm-integration/types/records";

import { crmRecordsColumnAdapters } from "./adapters";

export const createCrmRecordsColumList = (columns: readonly CrmRecordsColumn[]): readonly ColummListColumn<CrmRecordsRow>[] => {
    const columnDescriptorsList = createColumnFactoryList<CrmRecordsRow, CrmRecordColumnDataType, CrmRecordsColumn>([
        ["text", crmRecordsColumnAdapters.createTextColumnAdapter()],
        ["enum", crmRecordsColumnAdapters.createTextColumnAdapter()],
        ["date", crmRecordsColumnAdapters.createDateColumnAdapter()],
        ["crmRecord", crmRecordsColumnAdapters.createRecordColumnAdapter()],
    ]);

    return buildColumnsFromDescriptors({
        factoryList: columnDescriptorsList,
        descriptors: columns,
        getKey: (column) => column.dataType,
        fallback: crmRecordsColumnAdapters.createTextColumnAdapter(),
    });
}
